export default __webpack_public_path__ + "static/media/mahogany interior.e8157c77.jpg";